import React from "react";
import { InfoComponent } from "./InfoComponent";
import { readDataStorage } from "../../utils/storage/storage";
import { ApprovedComponent } from "./ApprovedComponent";
import { RepprovedComponent } from "./RepprovedComponent";

const Error404: React.FC = () => {
  const { situacao } = readDataStorage("block");
  switch (situacao) {
    case 0:
      return <InfoComponent />;

    case 1:
      return <ApprovedComponent />;

    case 2:
      return <RepprovedComponent />;
    default:
      return <div>Erro desconhecido</div>;
  }
};

export default Error404;